export const path2FileName = (path?: string): string => path?.replace(/^.*[\\/, \/, \:]/, '') || '';
